// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2jOX5","itemTitle":"ClientEmergencyInfo_itemTitle__3rLdw","itemText":"ClientEmergencyInfo_itemText__3AAey"};